var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2261 2.25H8.22607C5.05607 2.25 2.47607 4.83 2.47607 8V16C2.47607 19.17 5.05607 21.75 8.22607 21.75H16.2261C19.3961 21.75 21.9761 19.17 21.9761 16V8C21.9761 4.83 19.3961 2.25 16.2261 2.25ZM20.4761 16C20.4761 18.34 18.5661 20.25 16.2261 20.25H8.22607C5.88607 20.25 3.97607 18.34 3.97607 16V8C3.97607 5.66 5.88607 3.75 8.22607 3.75H16.2261C18.5661 3.75 20.4761 5.66 20.4761 8V16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2261 12.75C14.2961 12.75 15.9761 11.07 15.9761 9C15.9761 6.93 14.2961 5.25 12.2261 5.25C10.1561 5.25 8.47607 6.93 8.47607 9C8.47607 11.07 10.1561 12.75 12.2261 12.75ZM12.2261 6.75C13.4661 6.75 14.4761 7.76 14.4761 9C14.4761 10.24 13.4661 11.25 12.2261 11.25C10.9861 11.25 9.97607 10.24 9.97607 9C9.97607 7.76 10.9861 6.75 12.2261 6.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2261 14.25H10.2261C8.15607 14.25 6.47607 15.93 6.47607 18C6.47607 18.41 6.81607 18.75 7.22607 18.75C7.63607 18.75 7.97607 18.41 7.97607 18C7.97607 16.76 8.98607 15.75 10.2261 15.75H14.2261C15.4661 15.75 16.4761 16.76 16.4761 18C16.4761 18.41 16.8161 18.75 17.2261 18.75C17.6361 18.75 17.9761 18.41 17.9761 18C17.9761 15.93 16.2961 14.25 14.2261 14.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonCircleIcon);
export default __webpack_public_path__ + "static/media/person-circle-icon.59327bf7e757bd5cabf750015802bddf.svg";
export { ForwardRef as ReactComponent };